module.exports = __webpack_public_path__ + "img/banner.eaa47e8d.png";